import { render, staticRenderFns } from "./CircleProgress.vue?vue&type=template&id=3a2f80fa&scoped=true&"
import script from "./CircleProgress.vue?vue&type=script&lang=js&"
export * from "./CircleProgress.vue?vue&type=script&lang=js&"
import style0 from "./CircleProgress.vue?vue&type=style&index=0&id=3a2f80fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2f80fa",
  null
  
)

export default component.exports